import React, { useState, useEffect, useCallback } from 'react';
import '../styles/ImageLightbox.css';

const ImageLightbox = ({ images, currentIndex, onClose, imageType = 'file' }) => {
    const [currentImgIndex, setCurrentImgIndex] = useState(currentIndex || 0);

    useEffect(() => {
        setCurrentImgIndex(currentIndex || 0);
    }, [currentIndex]);

    const nextImage = useCallback(() => {
        setCurrentImgIndex((prev) => (prev + 1) % images.length);
    }, [images.length]);

    const prevImage = useCallback(() => {
        setCurrentImgIndex((prev) => (prev - 1 + images.length) % images.length);
    }, [images.length]);

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === 'Escape') {
                onClose();
            } else if (e.key === 'ArrowLeft') {
                prevImage();
            } else if (e.key === 'ArrowRight') {
                nextImage();
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
            document.body.style.overflow = 'auto';
        };
    }, [currentImgIndex, nextImage, prevImage, onClose]);

    const getImageSrc = (img) => {
        if (imageType === 'base64' || img.startsWith('data:image')) {
            return img;
        }
        return `${process.env.PUBLIC_URL}/${img}`;
    };

    if (!images || images.length === 0) return null;

    return (
        <div className="image-lightbox" onClick={onClose}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                <button className="lightbox-close" onClick={onClose}>&times;</button>
                <button className="lightbox-nav lightbox-prev" onClick={prevImage}>
                    ‹
                </button>
                <div className="lightbox-image-container">
                    <img
                        src={getImageSrc(images[currentImgIndex])}
                        alt={`${currentImgIndex + 1} of ${images.length}`}
                        className="lightbox-image"
                    />
                </div>
                <button className="lightbox-nav lightbox-next" onClick={nextImage}>
                    ›
                </button>
                {images.length > 1 && (
                    <div className="lightbox-counter">
                        {currentImgIndex + 1} / {images.length}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageLightbox;

